export enum PageState {
	AssistanceAdjust = 0,
	Patients = 1,
	PlanificationAssistance = 2,
	NursingFunctions = 3,
	Dashboard = 4,
}

export const transition = {
	duration: 0.6,
	ease: [0.25, 0.1, 0.25, 1],
};
